module.exports = {"id":"201266","name":"Kasper Kusk","rating":"71","photo":"./data/images/photos/2/201266.png","club":{"name":"Aalborg BK","logo":"./data/images/clubs/AalborgBK.png"},"positions":["MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KasperKusk0.json
// module id = 2299
// module chunks = 0